<template>
  <div style="padding:10px;background-color: #F5F5F5;min-height: 100%">

    <Card  :bordered="false" :dis-hover="true" style="margin-bottom:10px;">
      <div style="text-align:left">
        <Row>
          <Col span="19">
            <Button type="primary" @click="modal1=true;detail={spid:0}">增加</Button>
            <cite>|</cite>
            <span class="font-fuzhu">已结束或取消的课程不会在小程序列表展示。</span>
          </Col>
          <Col span="5">
             <Input search enter-button placeholder="输入关键词搜索" v-model="serch.key"  @on-search="load"/>
          </Col>
        </Row>
      </div>
    </Card>

    <Card :dis-hover="true">
      <Spin fix v-if="loading"></Spin>
      <el-table :data="list" size="small" style="width: 100%" >
        <el-table-column prop="id" label="编号" width="80" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="spid" label="课程编号" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="note" label="课程信息" :show-tooltip-when-overflow="true"></el-table-column>

        <el-table-column prop="msg" label="操作" width="80" fixed="right">
          <template slot-scope="scope">
            <a @click="remove(scope.row.id)">删除</a>
          </template>
        </el-table-column>
      </el-table>
    </Card>

    <Card  :bordered="false" dis-hover style="text-align: center;margin-top:10px">
      <Page :total="count" show-total :page="page" @on-page-size-change="limitChange"  show-elevator @on-change="change"  show-sizer :page-size-opts="[10, 30,50,100]"></Page>
    </Card>

    <Modal
      v-model="modal1"
      title="增加或编辑"
      @on-ok="save">
      <Form :label-width="80">
				<FormItem label="主推课程" required>
          <Spselect v-model="detail.spid"></Spselect>
				</FormItem>
      </Form>
    </Modal>

  </div>
</template>

<script>
  import Spselect from "../common/Spselect";
  export default {
    components:{Spselect},
    data(){
      return{
        baseUrl:'/api/zhutui/',
        list:[],
        page:1,
        count:0,
        limit:10,
        modal1:false,
        detail:{spid:0},
        serch:{
          key:''
        },
        loading:false,
      }
    },
    methods:{
      load(){
        let that = this;
        let params = [];
        if(this.serch.key){
          params.push('t.note@like@'+this.serch.key);
        }
        that.loading = true;
        this.$axios.get(this.baseUrl+'findall?page='+this.page+'&limit='+this.limit+'&params='+params).then(function(rs){
          that.list = rs.data.data;
          that.count = rs.data.count;
          that.loading = false;
        });
      },
      limitChange(val){
        this.limit = val;
        this.load();
      },
      change(val){
        this.page = val;
        this.load();
      },
      save(){
        let that = this;
        let data = Object.assign({}, this.detail);
        this.$axios({url:this.baseUrl+'save',method:'post',data:this.$qs.stringify(data)}).then(function(rs){
          that.toast(rs.data);
          if(rs.data.success){
            that.detail = {};
          }
        });
      },
      edit(id){
        let that = this;
        this.$axios.get(this.baseUrl+'getById?id='+id).then(function(rs){
          that.detail = rs.data;
          that.modal1 = true;
        });
      },
      remove(id){
        this.$Modal.confirm({
          title: '系统提示',
          content: '确定要删除吗',
          onOk: () => {
            let that = this;
            this.$axios.get(this.baseUrl+'delete?ids='+id).then(function(rs){
              that.toast(rs.data);
            });
          },
        });
      },
      toast(data){
        if(data.success){
          this.load();
          this.$Message.success(data.msg);
        }else{
          this.$Message.error(data.msg);
        }
      }
    },
    created(){
      this.load();
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/zhutui/Zhutui.vue